import { render, staticRenderFns } from "./TenderForm.vue?vue&type=template&id=94003b72&scoped=true"
import script from "./TenderForm.vue?vue&type=script&lang=js"
export * from "./TenderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94003b72",
  null
  
)

export default component.exports